import CreateEmployee from "./CreateEmployee";

export default CreateEmployee;
